var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnBasketMobileBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.509 14.909H4.874l-2.25-8.158h13.134l-2.25 8.158zM9.192 2c1.719 0 3.157 1.17 3.598 2.751H5.593C6.033 3.17 7.472 2 9.192 2zm5.658 2.751C14.374 2.056 12.02 0 9.192 0c-2.83 0-5.183 2.056-5.66 4.751H0l3.35 12.158h11.682l3.35-12.158H14.85z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

export default SvgIcnBasketMobileBlack;